import { CategoriesCategory } from './categories-category';
import './categories.scss';
import { CategoryT, SharedCategoriesProps } from './types';

type Props = SharedCategoriesProps & {
    isSubcategoryVisible?: boolean;
    categories: CategoryT[];
    selected: string[];
    index: number;
    toggleSubCategory: (id: string, index: number) => void;
};
export const CategoriesSubcategories = ({
    isSubcategoryVisible,
    categories,
    selected,
    index,
    toggleSubCategory,
    isIconVisible,
    isNameVisible,
}: Props) => {
    if (!isSubcategoryVisible || selected.length === 0) {
        return null;
    }

    const subcategories = categories.find(({ id }) => id === selected[index])?.subCategories;
    if (!subcategories || !subcategories.length) {
        return null;
    }

    return (
        <>
            <div className="categories__list" date-testid="categories-subcategories">
                {subcategories.map(({ subCategories: _, ...props }) => (
                    <CategoriesCategory
                        key={props.id}
                        isSelected={selected[index + 1] === props.id}
                        isSubcategory
                        isIconVisible={isIconVisible}
                        isNameVisible={isNameVisible}
                        onClick={() => toggleSubCategory(props.id, index + 1)}
                        {...props}
                    />
                ))}
            </div>
            <CategoriesSubcategories
                isSubcategoryVisible={isSubcategoryVisible}
                categories={subcategories}
                selected={selected}
                index={index + 1}
                toggleSubCategory={toggleSubCategory}
                isIconVisible={isIconVisible}
                isNameVisible={isNameVisible}
            />
        </>
    );
};
